import * as React from 'react'
import Switch from '@mui/material/Switch'
import FormControlLabel from '@mui/material/FormControlLabel'

interface SwitchInputProps {
  value: boolean
  onChange: (newValue: boolean) => void,
  style: any
}

export const SwitchInput: React.FC<SwitchInputProps> = ({ value, onChange, style }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked)
  }

  return <FormControlLabel style={style} control={<Switch checked={value} onChange={handleChange} />} label={null} />
}
